export interface UmpireComponent<T> {
  id: string | null;

  kind: T;

  index: number;

  relationshipNames?: string[];

  type: 'component';
}
